import { useTranslation } from 'react-i18next';
import { useUiStore } from '@/store/useUiStore';

/** AR ⇄ EN switch. Label shows the language you'd switch TO (plan §7). */
export default function LangToggle() {
  const { t } = useTranslation();
  const lang = useUiStore((s) => s.lang);
  const toggleLang = useUiStore((s) => s.toggleLang);

  return (
    <button
      type="button"
      className="toggle-btn lang-toggle"
      onClick={toggleLang}
      aria-label={t('nav.toggleLang')}
      lang={lang === 'ar' ? 'en' : 'ar'}
    >
      {t('nav.toggleLang')}
    </button>
  );
}
